import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { KeyboardFocusModule } from '@spartacus/storefront';
import { DisableInfoModule, ToggleStatusModule } from '@spartacus/organization/administration/components';
import { UigCardModule } from '../../shared/components/card/uig-card.module';
import { UigDeleteToggleStatusModule } from '../../shared/components/detail/uig-delete-toggle-status/uig-delete-toggle-status.module';
import { UigUserDetailsComponent } from './uig-user-details.component';
import { UigUserToggleStatusModule } from '../../shared/components/detail/uig-org-toggle-status/uig-user-toggle-status.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UrlModule,
    I18nModule,
    ToggleStatusModule,
    DisableInfoModule,
    KeyboardFocusModule,
    UigCardModule,
    UigDeleteToggleStatusModule,
    UigUserToggleStatusModule
  ],
  declarations: [UigUserDetailsComponent],
  exports: [UigUserDetailsComponent]
})
export class UigUserDetailsModule { }
